import { Routes } from '@angular/router';
import { signinGuard } from './core/guards/signin.guard';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: '',
        canActivate: [signinGuard],
        loadChildren: () => import('./auth/auth.routes').then(m => m.authRoutes)
    },
    {
        path: '',
        canActivate: [authGuard],
        loadChildren: () => import('./layout/layout.routes').then(m => m.layoutsRoutes)
    },

    { path: '', redirectTo: '/', pathMatch: 'full' },
];
